<!--
  "Translates" a flash message from the backend intro a vue flash component
-->
<template><div></div></template>
<script>
import { EventBus } from '../eventbus.js';

export default {
    props: ['messages'],
    mounted() {
        const messages = JSON.parse(this.messages);
        const delayBetweenMessages = 1500;

        messages.forEach((message, i) => {
            setTimeout(() => {
                EventBus.$emit('flash', message);
            }, delayBetweenMessages * i);
        });
    }
};
</script>
